import { useTableProvider } from "../../providers";

import { MainContentComponent, TableComponent } from "components";
import {
  HeaderLeft,
  HeaderRight,
  TableHeadComponent,
  TableItems,
  TablePaginationComponent,
} from "..";

export function MainComponent() {
  const { isLoading } = useTableProvider();

  return (
    <MainContentComponent
      headerLeft={<HeaderLeft />}
      headerRight={<HeaderRight />}
    >
      <TableComponent>
        <TableComponent.Head>
          <TableHeadComponent />
        </TableComponent.Head>
        <thead>
          <tr>
            <th>Serial Number</th>
            <th>Device Name</th>
            <th>Brand Name</th>
            <th>Warranty Start Date</th>
            <th>Last Update</th>
            <th></th>
          </tr>
        </thead>
        <TableComponent.Body colCount={6} isLoading={isLoading}>
          <TableItems />
        </TableComponent.Body>
        <TableComponent.Pagination>
          <TablePaginationComponent />
        </TableComponent.Pagination>
      </TableComponent>
    </MainContentComponent>
  );
}
